import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PedidoService } from '../../core/services/pedido.service';
import { PagoService } from '../../core/services/pago.service';
import { CatalogoService } from '../../core/services/catalogo.service';
import { AlertService } from '../../core/services/alert.service';
import { WhatsappUtility } from '../../core/utility/whatsapp-utility';
import { UiLoadingComponent } from '../../shared/components/ui-loading.component';
import { CatalogoItemApi } from '../../core/models/api/auth-api';
import { PedidoDetalleApi, PedidoListApi } from '../../core/models/api/pedido-api';

@Component({
    selector: 'app-admin-pedidos',
    standalone: true,
    imports: [CommonModule, FormsModule, UiLoadingComponent],
    template: `
    <div class="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 class="text-2xl font-black text-gray-800">Pedidos</h2>
        <p class="text-sm text-gray-400 mt-1">Verifica comprobantes, aprueba pagos y mueve estados.</p>
      </div>
      <div class="flex flex-wrap items-end gap-3">
      <label class="block min-w-52">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Buscar</span>
        <input [(ngModel)]="key" (ngModelChange)="buscar($event)" placeholder="Nro, correo, teléfono, doc…" class="mt-1 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200 bg-white" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">Estado</span>
        <select [ngModel]="estadoFiltro()" (ngModelChange)="cambiarFiltro($event)" class="mt-1 rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-rose-200 bg-white">
          <option value="">Todos</option>
          <option *ngFor="let e of estados()" [value]="e.codigo">{{ e.nombre }}</option>
        </select>
      </label>
      </div>
    </div>

    <app-ui-loading *ngIf="loading()"></app-ui-loading>

    <div *ngIf="!loading() && !seleccionado()" class="bg-white rounded-[2rem] border border-rose-100 shadow-sm overflow-hidden">
      <table class="w-full text-sm">
        <thead>
            <tr class="text-left text-xs uppercase tracking-wide text-gray-400 border-b border-gray-100">
              <th class="px-5 py-3">Nro</th>
              <th class="px-5 py-3">Estado</th>
              <th class="px-5 py-3">Total</th>
              <th class="px-5 py-3">Entrega</th>
              <th class="px-5 py-3">Creado</th>
              <th class="px-5 py-3">Mover a</th>
            </tr>
        </thead>
        <tbody>
              <tr *ngFor="let p of pedidos()" class="border-b border-gray-50 hover:bg-rose-50/50">
                <td class="px-5 py-3 cursor-pointer" (click)="verDetalle(p.uuid)">
                  <p class="font-black text-gray-800">#{{ p.numeroPedido }}</p>
                  <p class="text-[11px] text-gray-400">{{ p.correoContacto }}</p>
                </td>
                <td class="px-5 py-3 cursor-pointer" (click)="verDetalle(p.uuid)"><span class="text-[10px] font-bold uppercase px-2 py-1 rounded-full bg-gray-100 text-gray-600">{{ p.estado }}</span></td>
                <td class="px-5 py-3 font-bold text-rose-500 cursor-pointer" (click)="verDetalle(p.uuid)">S/ {{ p.total.toFixed(2) }}</td>
                <td class="px-5 py-3 text-gray-600 cursor-pointer" (click)="verDetalle(p.uuid)">{{ p.fechaEntrega }} · {{ p.rangoHorario }}</td>
                <td class="px-5 py-3 text-gray-400 text-xs cursor-pointer" (click)="verDetalle(p.uuid)">{{ p.createdAt | date:'short' }}</td>
                <td class="px-5 py-3">
                  <div class="flex gap-1">
                    <select [(ngModel)]="estadoPick[p.uuid]" class="rounded-xl border border-gray-200 px-2 py-1.5 text-xs bg-white outline-none max-w-32">
                      <option value="">…</option>
                      <option *ngFor="let e of estados()" [value]="e.codigo">{{ e.nombre }}</option>
                    </select>
                    <button type="button" (click)="moverRapido(p)" [disabled]="!estadoPick[p.uuid]" class="px-3 py-1.5 rounded-xl text-white text-xs font-bold disabled:opacity-40 cursor-pointer" style="background-color: var(--bg-main);">OK</button>
                  </div>
                </td>
              </tr>
        </tbody>
      </table>
      <p *ngIf="pedidos().length === 0" class="px-5 py-8 text-center text-sm text-gray-400">No hay pedidos en este estado.</p>
      <div class="flex items-center justify-between px-5 py-3 border-t border-gray-100 text-sm">
        <button type="button" (click)="pagina(false)" [disabled]="page() <= 1" class="px-4 py-2 rounded-xl border border-gray-200 font-bold text-gray-600 disabled:opacity-40 cursor-pointer">Anterior</button>
        <span class="text-xs text-gray-400">Página {{ page() }} de {{ totalPages() }}</span>
        <button type="button" (click)="pagina(true)" [disabled]="page() >= totalPages()" class="px-4 py-2 rounded-xl border border-gray-200 font-bold text-gray-600 disabled:opacity-40 cursor-pointer">Siguiente</button>
      </div>
    </div>

    <div *ngIf="!loading() && seleccionado() as d" class="flex flex-col gap-4">
      <button type="button" (click)="volver()" class="self-start text-sm font-bold text-rose-500 hover:underline cursor-pointer">Volver al listado</button>
      <div class="bg-white rounded-[2rem] p-6 border border-rose-100 shadow-sm flex flex-col gap-4">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <h3 class="text-xl font-black text-gray-800">Pedido #{{ d.numeroPedido }}</h3>
          <span class="text-xs font-bold uppercase px-3 py-1 rounded-full bg-gray-100 text-gray-600">{{ d.estado }}</span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-600">
          <p><span class="font-bold">Contacto:</span> {{ d.correoContacto }}<span *ngIf="d.telefonoContacto"> · {{ d.telefonoContacto }}</span></p>
          <p><span class="font-bold">Entrega:</span> {{ d.fechaEntrega }} · {{ d.rangoHorario }}</p>
          <p><span class="font-bold">Comprobante:</span> {{ d.tipoComprobante }}</p>
          <p><span class="font-bold">Total:</span> <span class="font-black text-rose-500">S/ {{ d.total.toFixed(2) }}</span></p>
        </div>
        <div class="flex">
          <a [href]="waCliente(d)" target="_blank" rel="noopener" class="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-bold rounded-2xl cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h8m-8 4h8m-8-8h8M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            WhatsApp cliente
          </a>
        </div>
        <p *ngIf="d.mensajeTarjeta" class="text-sm text-gray-600 italic">Tarjeta: "{{ d.mensajeTarjeta }}"</p>
        <div>
          <p class="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">Items</p>
          <ul class="flex flex-col gap-1 text-sm text-gray-700">
            <li *ngFor="let it of (d.items ?? [])">{{ it.nombre }} × {{ it.cantidad }} — S/ {{ it.precioTotal.toFixed(2) }}
              <span *ngIf="(it.complementos ?? []).length" class="text-gray-400">({{ it.complementos.join(', ') }})</span>
            </li>
          </ul>
        </div>
        <div *ngIf="(d.comprobantes ?? []).length">
          <p class="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">Vouchers</p>
          <div class="flex flex-wrap gap-3">
            <a *ngFor="let url of d.comprobantes" [href]="url" target="_blank" rel="noopener">
              <img [src]="url" alt="Voucher" class="w-28 h-28 object-cover rounded-2xl border border-gray-200" />
            </a>
          </div>
        </div>
        <div *ngIf="d.estadoCodigo === 'PAGO_POR_VERIFICAR'" class="flex flex-wrap items-center gap-2">
          <button type="button" (click)="aprobar(d.uuid)" class="px-5 py-2.5 rounded-2xl bg-emerald-500 text-white text-sm font-bold cursor-pointer">Aprobar pago</button>
          <input [(ngModel)]="motivo" placeholder="Motivo del rechazo" class="flex-1 min-w-40 rounded-2xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
          <button type="button" (click)="rechazar(d.uuid)" [disabled]="!motivo().trim()" class="px-5 py-2.5 rounded-2xl bg-red-500 text-white text-sm font-bold disabled:opacity-40 cursor-pointer">Rechazar</button>
        </div>
        <div class="flex flex-wrap items-center gap-2 border-t border-gray-100 pt-4">
          <select [(ngModel)]="nuevoEstado" class="rounded-2xl border border-gray-200 px-4 py-2.5 text-sm bg-white outline-none focus:ring-2 focus:ring-rose-200">
            <option value="">Cambiar estado a…</option>
            <option *ngFor="let e of estados()" [value]="e.codigo">{{ e.nombre }}</option>
          </select>
          <input [(ngModel)]="comentario" placeholder="Comentario (opcional)" class="flex-1 min-w-40 rounded-2xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-rose-200" />
          <button type="button" (click)="cambiarEstado(d.uuid)" [disabled]="!nuevoEstado()" class="px-5 py-2.5 rounded-2xl text-white text-sm font-bold disabled:opacity-40 cursor-pointer" style="background-color: var(--bg-main);">Aplicar</button>
        </div>
        <div>
          <p class="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">Historial</p>
          <ul class="flex flex-col gap-1 text-xs text-gray-500">
            <li *ngFor="let h of d.historial">{{ h.createdAt | date:'short' }} — <span class="font-bold">{{ h.estado }}</span><span *ngIf="h.comentario"> · {{ h.comentario }}</span></li>
          </ul>
        </div>
      </div>
    </div>
    `
})
export class AdminPedidosComponent implements OnInit {
    private pedidosService = inject(PedidoService);
    private pagos = inject(PagoService);
    private catalogo = inject(CatalogoService);
    private alerts = inject(AlertService);

    loading = signal(true);
    pedidos = signal<PedidoListApi[]>([]);
    estados = signal<CatalogoItemApi[]>([]);
    estadoFiltro = signal('');
    key = signal('');
    page = signal(1);
    total = signal(0);
    pageSize = 9;
    seleccionado = signal<PedidoDetalleApi | null>(null);
    motivo = signal('');
    nuevoEstado = signal('');
    comentario = signal('');
    estadoPick: Record<string, string> = {};
    private searchTimer: ReturnType<typeof setTimeout> | null = null;

    ngOnInit(): void {
        this.catalogo.listEstadosPedido().subscribe({
            next: (rows) => this.estados.set(rows),
            error: () => undefined
        });
        this.cargar();
    }

    totalPages(): number {
        return Math.max(1, Math.ceil(this.total() / this.pageSize));
    }

    cambiarFiltro(codigo: string) {
        this.estadoFiltro.set(codigo);
        this.page.set(1);
        this.cargar();
    }

    buscar(term: string) {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
            this.page.set(1);
            this.cargar();
        }, 400);
    }

    moverRapido(p: PedidoListApi) {
        const codigo = this.estadoPick[p.uuid];
        if (!codigo) {
            return;
        }
        this.pedidosService.cambiarEstado(p.uuid, codigo, null).subscribe({
            next: () => {
                this.alerts.ok(`Pedido #${p.numeroPedido} movido`);
                this.estadoPick[p.uuid] = '';
                this.cargar();
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo cambiar el estado.')
        });
    }

    waCliente(d: PedidoDetalleApi): string {
        const text = `Hola, te escribimos por tu pedido #${d.numeroPedido} (${d.estado}) de S/ ${d.total.toFixed(2)}, entrega ${d.fechaEntrega}.`;
        const direct = WhatsappUtility.waLink(d.telefonoContacto, text);
        if (direct) {
            return direct;
        }
        return `https://wa.me/?text=${encodeURIComponent(text)}`;
    }

    pagina(next: boolean) {
        this.page.update((p) => next ? p + 1 : Math.max(1, p - 1));
        this.cargar();
    }

    verDetalle(uuid: string) {
        this.loading.set(true);
        this.pedidosService.getPedido(uuid).subscribe({
            next: (d) => {
                this.seleccionado.set(d);
                this.motivo.set('');
                this.nuevoEstado.set('');
                this.comentario.set('');
                this.loading.set(false);
            },
            error: (err) => {
                this.loading.set(false);
                this.alerts.error(err?.message || 'No se pudo cargar el pedido.');
            }
        });
    }

    volver() {
        this.seleccionado.set(null);
        this.cargar();
    }

    aprobar(uuid: string) {
        this.pagos.aprobarPago(uuid).subscribe({
            next: () => {
                this.alerts.ok('Pago aprobado');
                this.verDetalle(uuid);
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo aprobar.')
        });
    }

    rechazar(uuid: string) {
        if (!this.motivo().trim()) {
            return;
        }
        this.pagos.rechazarPago(uuid, this.motivo().trim()).subscribe({
            next: () => {
                this.alerts.ok('Pago rechazado');
                this.verDetalle(uuid);
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo rechazar.')
        });
    }

    cambiarEstado(uuid: string) {
        if (!this.nuevoEstado()) {
            return;
        }
        this.pedidosService.cambiarEstado(uuid, this.nuevoEstado(), this.comentario().trim() || null).subscribe({
            next: () => {
                this.alerts.ok('Estado actualizado');
                this.verDetalle(uuid);
            },
            error: (err) => this.alerts.error(err?.message || 'No se pudo cambiar el estado.')
        });
    }

    private cargar() {
        this.loading.set(true);
        this.pedidosService.listPedidosStaff(this.estadoFiltro() || undefined, this.key() || undefined, this.page(), this.pageSize).subscribe({
            next: (res) => {
                this.pedidos.set(res.data);
                this.total.set(res.total);
                this.loading.set(false);
            },
            error: (err) => {
                this.loading.set(false);
                this.alerts.error(err?.message || 'No se pudieron cargar los pedidos.');
            }
        });
    }
}
